import { render, staticRenderFns } from "./storageAssetsHome.vue?vue&type=template&id=051e2100&scoped=true&"
import script from "./storageAssetsHome.vue?vue&type=script&lang=js&"
export * from "./storageAssetsHome.vue?vue&type=script&lang=js&"
import style0 from "./storageAssetsHome.vue?vue&type=style&index=0&id=051e2100&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051e2100",
  null
  
)

export default component.exports